module.exports = __webpack_public_path__ + "static/media/energy2.e25248b9.jpg";